import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  Card,
  CardContent,
  CardHeader,
  List,
  ListItem,
  ListItemText,
  Typography,
  Chip,
  Box,
} from '@mui/material'
import { TestResult } from '../../types/dashboard'

interface RecentTestResultsProps {
  results: TestResult[]
}

export const RecentTestResults: React.FC<RecentTestResultsProps> = ({ results }) => {
  const { t, i18n } = useTranslation('dashboard')

  return (
    <Card>
      <CardHeader title={t('recentTestResults.title')} />
      <CardContent sx={{ pt: 0 }}>
        {results.length === 0 ? (
          <Typography variant="body2" color="textSecondary" textAlign="center" py={2}>
            {t('recentTestResults.noResults')}
          </Typography>
        ) : (
          <List disablePadding>
            {results.map((result, index) => (
              <ListItem
                key={result.id}
                sx={{
                  px: 0,
                  borderBottom: index < results.length - 1 ? '1px solid #f0f0f0' : 'none',
                }}
              >
                <ListItemText
                  primary={
                    <Box display="flex" alignItems="center" justifyContent="space-between" gap={1}>
                      <Typography
                        variant="body2"
                        sx={{
                          flexGrow: 1,
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          minWidth: 0,
                        }}
                      >
                        {result.test.title}
                      </Typography>
                      <Chip
                        label={`${result.score}点`}
                        color={result.passed ? 'success' : 'error'}
                        size="small"
                        sx={{ flexShrink: 0 }}
                      />
                    </Box>
                  }
                  secondary={
                    <Box display="flex" alignItems="center" justifyContent="space-between">
                      <Typography variant="caption" color="textSecondary">
                        {result.test.complianceRule.category}
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        {new Date(result.completedAt).toLocaleDateString(
                          i18n.language === 'en' ? 'en-US' : 'ja-JP'
                        )}
                      </Typography>
                    </Box>
                  }
                />
              </ListItem>
            ))}
          </List>
        )}
      </CardContent>
    </Card>
  )
}
